import router from '../router';
import videoStart from './videoStart';
import vars from '../globals';

const $document = $(document);
const $test = $('.test');
const $preloader = $test.find('.test-preloader');
const $steps = $test.find('.test__step');
const $contents = $test.find('.test__content');
const $headers = $test.find('.test__header');
const $variants = $test.find('.test__variants');
const $checkboxes = $test.find('.test__checkbox');
const $answers = $test.find('.test__answer');
const $answerTexts = $test.find('.test__answer-text');
const $videoContainers = $test.find('.test__video');
const $videos = $test.find('.test-video');

let points = 0;
let videoInitialState = false;

function goTop() {
	$('html, body').animate({
		scrollTop: 0,
	}, 300);
}

const showVideo = (i) => {
	setTimeout(() => {
		$preloader.addClass('is-hidden');
		$steps.filter(`[data-number="${i}"]`).removeClass('is-hidden');

		$(`#video-container-${i}`)
			.removeClass('is-hidden')
			.trigger('test-step', [i]);
	}, 2000);
};

let test = {

	initVideos() {
		if (videoInitialState) {
			return;
		}

		videoStart($videos);

		videoInitialState = true;
	},

	start() {
		this.clear();

		showVideo(1);

		vars.$document.trigger('test-start');
	},

	answer($this) {
		const $step = $this.closest('.test__step');
		const $answerRight = $step.find('.test__answer-text--right');
		const $stepContent = $step.find('.test__content');
		const $answerContainer = $step.find('.test__answer');
		const windowHeight = $(window).height();

		let stepOffsetTop;
		let answerHeight;
		let questionHeight;
		let stepPaddingTop;
		let yPosition;
		let kScale = 1;
		let animationTime = 0.5;

		if (!$step.hasClass('is-answered')) {
			$step.addClass('is-answered');
			$document.trigger('test-answer', [$answerRight]);
		}

		if ($this.data('truthful') === true) {
			$this.addClass('is-true');

			points++;
		} else {
			$this.addClass('is-false');
		}

		$answerContainer.removeClass('is-hidden');
		$step.find(`.test__answer-text--${$this.data('number')}`).removeClass('is-hidden');

		stepOffsetTop = $step.offset().top;
		stepPaddingTop = $step.css('padding-top').replace('px', '');
		questionHeight = $step.find('.test__content').outerHeight();
		answerHeight = $answerContainer.outerHeight();
		yPosition = stepOffsetTop - answerHeight / 2 <= stepPaddingTop ? -stepOffsetTop : -answerHeight / 2;

		if (windowHeight - questionHeight - stepPaddingTop < answerHeight) {
			kScale = ((windowHeight - answerHeight - stepPaddingTop) / questionHeight).toFixed(2);
		}

		if (vars.isMobile()) {
			setTimeout(() => {
				$('html, body').stop().animate({
					scrollTop: $answerContainer.offset().top,
				}, 500);
			}, 750);
		} else {
			new TimelineMax()
				.from($answerContainer, animationTime, {
					y: answerHeight,
					clearProps: 'true',
				}).to($stepContent, animationTime, {
					transformOrigin: '50% 0',
					y: yPosition,
					scale: kScale,
					rotationZ: -0.0001,
					clearProps: 'true',
				}, 0);
		}
	},

	next($this) {
		if (window.innerWidth <= 1024) {
			goTop();
		}

		const testStepsQuantity = $steps.length;
		const $step = $this.closest('.test__step');
		const $nextStep = $step.next('.test__step');

		if ($step.data('number') < testStepsQuantity) {
			$step
				.addClass('is-hidden')
				.removeClass('is-answered');

			$steps.filter(`[data-number="${$nextStep.data('number')}"]`).removeClass('is-hidden');

			$(`#video-container-${$nextStep.data('number')}`)
				.removeClass('is-hidden')
				.trigger('test-step', [$nextStep.data('number')]);
		} else {
			$step
				.addClass('is-hidden')
				.removeClass('is-answered');

			router.navigate(`/result?points=${points}&total=${testStepsQuantity}`);
		}
	},

	clear() {
		points = 0;

		$steps
			.removeClass('is-answered')
			.addClass('is-hidden')
			.trigger('test-stop');

		$headers.addClass('is-hidden');
		$variants.addClass('is-hidden');
		$checkboxes.removeClass('is-true is-false');
		$answers.addClass('is-hidden');
		$answerTexts.addClass('is-hidden');
		$videoContainers.addClass('is-hidden');
		$preloader.removeClass('is-hidden');

		TweenMax.killTweensOf([$contents, $answers]);
		TweenMax.set([$contents, $answers], {clearProps: 'all'});
	},

};

$checkboxes.on('change', (e) => {
	test.answer($(e.currentTarget));
});

$('.test__button--next').on('click', (e) => {
	test.next($(e.currentTarget));
});

export default test;
